var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTagPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88307 2.3156L3.58193 3.57583L2.32171 9.87696C2.30153 9.97786 2.30657 10.0822 2.33639 10.1806C2.3662 10.2791 2.41987 10.3687 2.49263 10.4415L10.653 18.6019C10.711 18.6599 10.7799 18.7059 10.8558 18.7373C10.9316 18.7687 11.0129 18.7849 11.0949 18.7849C11.177 18.7849 11.2583 18.7687 11.3341 18.7373C11.4099 18.7059 11.4788 18.6599 11.5369 18.6019L18.608 11.5308C18.666 11.4727 18.712 11.4038 18.7434 11.328C18.7748 11.2522 18.791 11.1709 18.791 11.0888C18.791 11.0068 18.7748 10.9255 18.7434 10.8497C18.712 10.7738 18.666 10.7049 18.608 10.6469L10.4476 2.48653C10.3748 2.41377 10.2852 2.3601 10.1868 2.33028C10.0883 2.30047 9.98396 2.29543 9.88307 2.3156V2.3156Z",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8623 7.7937C7.38007 7.7937 7.7998 7.37397 7.7998 6.8562C7.7998 6.33843 7.38007 5.9187 6.8623 5.9187C6.34454 5.9187 5.9248 6.33843 5.9248 6.8562C5.9248 7.37397 6.34454 7.7937 6.8623 7.7937Z",
    fill: "#677791"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagPlain);
export default __webpack_public_path__ + "static/media/TagPlain.e93661bc594c994239fdb2994696a2e4.svg";
export { ForwardRef as ReactComponent };